<template>
  <div v-if="value" class="gary-first">
    <div class="show">
      <div class="award-box">
        <img class="award-ico" v-if="isStepAward" src="../assets/img/zql/extension_new/award-bg2.png" alt="">
        <img class="award-ico" v-else src="../assets/img/zql/extension_new/award-bg.png" alt="">
        <div class="content">
          <p class="money-t">
            <span class="num">{{curData.money}}</span>
            <span class="txt">元</span>
          </p>
          <div class="button c-fff" @click="receiveEv">
            <img src="../assets/img/zql/extension_new/receive-btn.png" alt="">
          </div>
        </div>
      </div>
      <img class="close" @click="close" src="../assets/img/zql/extension_new/icon_close.png" width="26px" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    curData: {
      type: Object,
      default:() =>{ 
        return {}
      }
    },
    isStepAward: {
      type: Boolean,
      default: true
    },
    isNewStepAward: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  methods: {
    receiveEv() {
      if (this.curData && this.curData.id) {
        if (this.isSaving) {
          return
        }
        this.isSaving = true;

        let url = '/user/activity2/rewardLevel' //阶梯奖励
        if(this.isNewStepAward){
          url = '/user/activity2/rewardNewLevel'
        } else if (!this.isStepAward) {
          url = '/user/activity2/rewardDetail'
        }
        this.$axios.post(url, {
          id: this.curData.id,
        }).then(res => {
          if (res.code == 200) {
            this.$bhUi.Toast({text:'领取成功'})
            this.$emit('receiveSuccess')
          }
          this.isSaving = false;
        }).catch(() => {
          this.isSaving = false;
        })
      } else {
        this.$bhUi.Toast({text:'活动Id不存在'})
      }
    },
    close() {
      this.$emit('input', false)
    }
  },
  mounted() {
  },
  created() {
  }
};
</script>
<style lang="less" scoped>
  .gary-first {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 800;
    background-color: rgba(0, 0, 0, 0.6);

    .show{
      position: relative;
      margin: 50% auto 0;
      border-radius: 6px;
      top: -50px;

      .award-box {
        font-size: 14px;

        .award-ico {
          margin: 0 auto 0;
          width: 100%;
        }
        .content {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
        }
        .money-t {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          font-weight: bold;
          color: #FF6234;
          
          .txt {
            font-size: 24px;
            line-height: 24px;
          }
          .num {
            font-size: 60px;
            line-height: 46px;
            margin-right: 6px;
          }
        }
        .button{
          border-radius: 60px;
          color: #fff;
          margin-bottom: 16px;
          margin-top: 60px;
          position: relative;

          img {
            width: 50%;
            max-width: 230px;
          }
        }
      }

      .close{
        position: absolute;
        bottom: -40px;
        left: 50%;
        transform: translateX(-50%);
      }
      .recommend-head{
        position: relative;
        width: 86vw;
        margin: 0 auto;
        color: #fff;

        .reco-text{
          position: absolute;
          text-align: center;
          top: 14px;
          left: 0;
          right: 0;
          span {
            font-size: 18px;
            font-weight: 400;
          }
        }

        .i-close {
          position: absolute;
          top: 12px;
          right: 12px;
        }
      }
    }
  }
</style>
